import numeral from 'numeral';

export const TICKET_TYPES = {
  PHOTO: 'photo',
  STADIUM: 'stadium',
};

const photoPriceTiers = [
  { label: '20 - 50', maxQty: 50, price: 1.99 },
  { label: '51 - 200', maxQty: 200, price: 1.89 },
  { label: '201 - 499', maxQty: 499, price: 1.79 },
  { label: '500+', maxQty: Infinity, price: 1.69 },
];

const stadiumPriceTiers = [
  { label: '1 - 10', maxQty: 11, price: 1.69 },
  { label: '11 - 25', maxQty: 26, price: 1.59 },
  { label: '26 - 100', maxQty: 101, price: 1.39 },
  { label: '101 - 250', maxQty: 251, price: 1.29 },
  { label: '251 - 1000', maxQty: Infinity, price: 1.09 },
];

export const priceTiersByTicketType = {
  [TICKET_TYPES.PHOTO]: photoPriceTiers,
  [TICKET_TYPES.STADIUM]: stadiumPriceTiers,
};

export const getTicketPriceTiers = (ticketType = TICKET_TYPES.PHOTO) =>
  priceTiersByTicketType[ticketType] ||
  priceTiersByTicketType[TICKET_TYPES.PHOTO];

const perTicketPrice = (qty = 0, ticketType = TICKET_TYPES.PHOTO) => {
  const priceTiers = getTicketPriceTiers(ticketType);
  const priceTier =
    priceTiers.find(({ maxQty }) => qty <= maxQty) ||
    priceTiers[priceTiers.length - 1];

  return numeral(priceTier.price).value();
};

export default perTicketPrice;
